import React, { Fragment, useState, useEffect } from 'react';

import './CourseEmailPopup.scss';
import { isExternalLink } from '../../helpers/link';
import icons from '../../shared/assets/icons/redesign';

const { Play, Check } = icons;

export default function CourseEmailPopup({
  user,
  title,
  router,
  imageUrl,
  NextLink,
  targetUri,
  description,
  addUserEvent,
  showEmailPopup,
  emailIsSubmitted
}) {
  const [isSubmitted, setIsSubmitted] = useState(emailIsSubmitted || false);

  return (
    <div className="courseEmailPopup">
      <div className="courseEmailPopup-content">
        <div className="courseEmailPopup-header">
          Dankjewel voor je interesse!

          <span
            onClick={() => showEmailPopup(false)}
            className="courseEmailPopup-close-icon">
            &times;
          </span>
        </div>

        <div className="courseEmailPopup-body">
          {isSubmitted ? (
            <Fragment>
              <div className="courseEmailPopup-check-icon-wrap">
                <Check className="courseEmailPopup-check-icon" />
              </div>

              <h3 className="courseEmailPopup-confirmation-title">
                Je gegevens zijn ontvangen
              </h3>

              <p className="courseEmailPopup-confirmation-text">
                Je e-mail adres is opgeslagen. Wanneer de online curussen gereed
                zijn ontvang jij een kortingscode met 25% korting.
              </p>

              <div className="courseEmailPopup-form-button-wrap
                courseEmailPopup-form-dashboard-button-wrap">
                <NextLink href={user.username ? '/dashboard' : '/'}>
                  <button className="courseEmailPopup-form-button">
                    Naar Dashboard
                  </button>
                </NextLink>
              </div>
            </Fragment>
          ) :
            <Fragment>
              <div className="courseEmailPopup-message-text">
                <p>Momenteel zijn we nog bezig de cursussen samen te stellen.</p>
                <p>
                  Laat je e-mail adres achter en ontvang 25% korting wanneer we
                  live gaan; dit zal niet lang meer duren!
                </p>
              </div>

              <form
                className="courseEmailPopup-form"
                onSubmit={e => sendEmail(e, addUserEvent)}>
                {!user.email &&
                  <Fragment>
                    <label
                      className="courseEmailPopup-form-email-label"
                      htmlFor="email">Jouw e-mail adres
                    </label>

                    <input
                      required
                      autoFocus
                      id="email"
                      type="email"
                      name="email"
                      className="courseEmailPopup-form-email-field"
                    />
                  </Fragment>
                }

                <div className="courseEmailPopup-form-button-wrap">
                  <input
                    type="submit"
                    value="Verzenden"
                    className="courseEmailPopup-form-button" />
                </div>
              </form>
            </Fragment>}
        </div>
      </div>
    </div>
  );

  function sendEmail(e) {
    e.preventDefault();

    addUserEvent({ variables: {
      type: 'interest.courses',
      data: JSON.stringify({
        email: user.email || e.target.email.value,
        ...(user.username && { username: user.username })
      })
    } });

    setIsSubmitted(true);

    history.replaceState({}, '', targetUri);
  }
}
